import styled from 'styled-components';

export const Container = styled.div``;

export const Space = styled.div`
  height: 34px;
`;
